module.exports = __webpack_public_path__ + "static/media/lexus-icon-noneOption.fb7cb6f4.svg";